import React from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";
const faqData = [
    {
        question:
            "What does offshore team setup usually include?",
        answer:
            "It usually includes defining the right roles, building the team structure, aligning workflows and supporting day-to-day delivery.",
    },
    {
        question:
            "How is this different from traditional outsourcing?",
        answer:
            "The focus is on integration and continuity. Offshore teams are set up to work with your internal processes rather than operating as a separate delivery layer.",
    },
    {
        question:
            "Can the offshore team work with our existing tools and workflows?",
        answer:
            "Yes. Teams are aligned with your communication tools, project workflows, and delivery processes from the start.",
    },
    {
        question:
            "Can the team scale as our requirements change?",
        answer:
            "Yes. Team size and role distribution can expand or adjust as delivery needs evolve",
    },
    {
        question:
            "What kind of roles can be part of the offshore team?",
        answer:
            "Depending on the need, teams can include developers, testers, DevOps support, and other technical roles.",
    },
    {
        question:
            "Can offshore teams work in our time zone?",
        answer:
            "Yes. Teams can adjust working hours based on your collaboration needs.",
    },
];

export default function FAQ() {
    return (
        <section className='padding-section-large faq-section'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Frequently Asked <span className="text-gradient-1">Questions</span></h2>
                    </Col>
                </Row>
                <Accordion defaultActiveKey="0" flush>
                    {faqData.map((faq, index) => (
                        <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="faq-item"
                        >
                            <Accordion.Header>
                                {faq.question}
                            </Accordion.Header>
                            <Accordion.Body>
                                {faq.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
        </section>
    );
}